if (typeof cpac !== 'undefined') {
    cpac.caReportGenerator = {
        addFilterToReport: function (obj, parent, key, isDailyBilling, variable, additional_variable) {

            if ($j(obj).is(':checked')) {

                var container = $j('.filter-' + parent + '-' + key + '-container');
                if (container.length == 0) {
                    if (parent == 'addonresource' && additional_variable === undefined) {
                        additional_variable = $j('#group_id').val();
                    }

                    if(isDailyBilling){
                        showResources('', '/reportelementsdaily/add', 'filters-array', '', 'ajax=1&type=' + parent + '&field=' + key + '&variable=' + variable + '&additional_variable=' + additional_variable, false, 'post', 'append');
                    } else {
                        showResources('', '/reportelements/add', 'filters-array', '', 'ajax=1&type=' + parent + '&field=' + key + '&variable=' + variable + '&additional_variable=' + additional_variable, false, 'post', 'append');
                    }


                    if (parent == 'childcareattendance' && (key == 'timein' || key == 'timeout') && !$j('#add-filter-daterange').is(':checked')){
                        $j('#add-filter-daterange').attr('checked', 'checked');
                        if(isDailyBilling){
                            showResources('', '/reportelementsdaily/add', 'filters-array', '', 'ajax=1&type=' + parent + '&field=daterange', false, 'post', 'append');
                        } else {
                            showResources('', '/reportelements/add', 'filters-array', '', 'ajax=1&type=' + parent + '&field=daterange', false, 'post', 'append');
                        }
                    }
                }
            }
            else {
                if (parent == 'childcareattendance' && (key=='daterange') && ($j('#add-filter-timein').is(':checked') || $j('#add-filter-timeout').is(':checked'))){
                    $j('#add-filter-daterange').attr('checked', 'checked');
                    return false;
                }

                if (!variable || variable == 'undefined') {
                    var container = $j('.filter-' + parent + '-' + key + '-container');

                    if (container.length > 0) {
                        container.remove();
                    }
                }
                else {
                    var container = $j('.filter-' + parent + '-' + key + '-' + variable + '-container');

                    if (container.length > 0) {
                        container.remove();
                    }
                }
            }
        },

        addAgingCustomPeriod: function(parent, key) {
            var container = $j('.filter-' + parent + '-' + key + '-container');
            if (container.length == 0) {
                showResources('', '/reportelements/add', 'filters-array', '', 'ajax=1&type=' + parent + '&field=' + key + '&variable=&additional_variable=', false, 'post', 'append');
            }
        },

        removeAgingCustomPeriod: function(parent, key) {
            var container = $j('.filter-' + parent + '-' + key + '-container');
            if (container.length > 0) {
                container.remove();
            }
        },

        saveViewReport: function () {
            var reportName = $j('#reportName').val();
            var reportAction = $j('#reportAction').val();
            var accessLevel = $j('#access_level').val();
            var template = $j('#template_id').val();
            reportNameString = escape(reportName);

            if (reportName != 'undefined' && reportName) {
                showResources($j('form'), '/report/save', 'save_result_div', '', 'save=1&accessLevel=' + accessLevel + '&reportName=' + reportNameString + '&template=' + template + '&reportAction=' + reportAction);
                $j.caDialogCloseAll();
            }
        },
        updateViewReport: function () {
            var reportName = $j('#reportName').val();
            var reportAction = $j('#reportAction').val();
            var accessLevel = $j('#access_level').val();
            var report_id = $j('#update_report_id').val();
            if (reportName !== 'undefined' && reportName) {
                showResources(
                    $j('#form'),
                    '/report/save',
                    'save_result_div',
                    '',
                    'save=1&accessLevel=' + accessLevel + '&reportName=' + reportName + '&update_report=1&report_id=' + report_id + '&reportAction=' + reportAction,
                    null,
                    'POST'
                );
                $j.caDialogCloseAll();
            }
        },
        manageSavedViews: function () {
            $j.caAjax({
                url: '/report/manage-saved-views?ajax=1',
                type: 'post',
                dataType: 'json',
                data: $j('#manage-saved-views-form').serializeArray(),
                loadingSplash : true,
                success: function(response) {
                    var message = $j('#manage-views-message');
                    message.find('span').text(response.message);

                    if (response.status) {
                        for (var i=0; i<response.deleted.length; i++) {
                            $j('#report_view_block_' + response.deleted[i]).remove();

                            $j("#selectReportView option[value='"+response.deleted[i]+"']").remove();

                            if ($j("#selectReportView option").length == 2) {
                                var groups = $j("#selectReportView optgroup");
                                $j("<option></option>").attr("value", -1).text("No saved reports").appendTo(groups[0]);
                            }
                        }

                        if (!$j('#views-block').children().length) {
                            $j('#views-block').hide();
                            $j('#no-views-message').show();
                        }

                        message.removeClass('error');
                        message.addClass('success');
                    } else {
                        message.removeClass('success');
                        message.addClass('error');
                    }

                    setTimeout(function(){
                        message.fadeOut("slow");
                    }, 5000);

                    $j.caDialogCloseAll();

                    message.show();
                }
            });
        },
        setReportOrder: function (field) {
            if (field != 'undefined' && field) {
                if ($j('#th_' + field).length > 0) {
                    order_field = $j('#order_field').val();
                    order_order = $j('#order_order').val();
                    if (order_field == field) {
                        if (order_order == 'ASC') {
                            $j('#order_order').val('DESC');
                        }
                        else {
                            $j('#order_order').val('ASC');
                        }
                    }
                    else {
                        $j('#order_field').val(field);
                        $j('#order_order').val('ASC');
                    }
                }
            }
            else {
                $j('#order_field').val('');
                $j('#order_order').val('');
            }

            $j('#form').submit();
        },

        removeGroupStatus: function (group_id) {
            if (group_id && group_id != 'undefined') {
                var element = $j('#' + group_id).attr("checked", false)[0];
                if (element) {
                    element.onclick();
                }
            }
        },

        submitEmailExport: function() {
            var allEmailsIds = '';
            if (jQuery('#all-ids').is(':checked') && jQuery('#all-users-ids').val() != undefined) {
                allEmailsIds = jQuery('#all-users-ids').val();
            } else {
                allEmailsIds = jQuery("input[name='user_checkbox\\[\\]']").map(function () {
                    if (jQuery(this).is(':checked')) {
                        return jQuery(this).val();
                    }
                })
                    .get()
                    .join(",");
            }

            jQuery('.export-email-data').each(function(){
                value = jQuery(this).val();
                if (value && value != -1) {
                    allEmailsIds = allEmailsIds != ''
                        ? allEmailsIds + ',' + value
                        : value;
                }
            });

            jQuery('#emails_ids').val(allEmailsIds);
            jQuery('#exported_report_name').val(document.title);
            jQuery('#email_send_form').submit();
        },

        submitEmailFullExport: function() {
            var params = jQuery('#form').serialize() + "&email=1";
            jQuery.caPost(
                jQuery('#form').attr('action'),
                params,
                function (response) {
                    if (response.status != 1) {
                        return;
                    }
                    var values = response.EmailExportId;
                    jQuery('#emails_ids').val(values);
                    jQuery('#exported_report_name').val(document.title);
                    jQuery('#email_send_form').submit();
                }
            );
        },

        submitStatementEmailRequest: function() {
            var onConfirm = function () {
                var form = $j('#form');
                $j('#export_type').val('doStatementEmailRequest');
                var values = form.serialize();
                var statementsForm = $j('#statements_form');

                if (statementsForm.length) {
                    values += statementsForm.serialize();
                }

                $j.caPost('/report/statements-email', values, function (response) {
                    $j.caAlert(response.message);
                    $j('#selectExport').val('');
                    $j('#export_type').val('');
                }, 'json');
            };

            $j.caConfirm(
                'Exporting to email will send a statement to everyone who is marked on the list. Would you like to email these statements?',
                '',
                'Yes',
                'No',
                onConfirm,
                function () {
                    $j('#selectExport').val('');
                    $j('#export_type').val('');
                }
            );
        },

        sumbitPayrollDetailsPdf: function() {
            $j('#payrollPdfDialog').caDialog('close');

            var startDate = $j('#filter-payroll-Date-from').val();
            var endDate = $j('#filter-payroll-Date-to').val();
            var prefix = $j('#pdfName').attr('placeholder');
            var title = (prefix ? prefix : 'Payroll Review Report ')
                + ((endDate == startDate) ? startDate : startDate + ' - ' + endDate);

            $j('#pdfName').val(title);

            $j('#payrollDetailsPdfDialog').caDialog({
                title: 'Generate PDF',
                modal: true,
                width: 380,
                resizable: false,
                showCloseButton: true
            });
        },

        submitExportReport: function (value, form_id, action_url) {
            if (!form_id || form_id == undefined) {
                form_id = 'form';
            }

            $j('#export_type').val(value);

            if (value != '') {
                var _tmp = $j('#'+form_id).attr('onsubmit');
                var form = $j('#'+form_id);
                form.attr('onsubmit', 'return true');
                url = form.attr('action');
                var formAction = url;

                if (action_url && action_url != 'undefined') {
                    url = action_url;
                }
                var paramsChar = (url.indexOf('?') !== -1) ? '&' : '?';
                form.attr('action', url + paramsChar + value + '=1');
                form.submit();
                form.attr('action', formAction);
                form.attr('onsubmit', _tmp);
                $j('#selectExport').val('');
            }
            $j('#export_type').val('');
        },

        openUrlToNewWindowViaPost : function(params, url){
            $j('.new-window-form').remove();
            var form = document.createElement("form");
            form.setAttribute('style',"display:none;");
            form.setAttribute('class',"new-window-form");
            form.setAttribute('method',"post");
            form.setAttribute('action',url);
            form.setAttribute('target',"_blank");

            $j.each(params, function (key, value) {
                if(typeof(value) == 'string') {
                    var input = document.createElement("input");
                    input.setAttribute('type',"text");
                    input.setAttribute("name",key);
                    input.setAttribute("value",value);
                    form.appendChild(input);
                } else if(typeof(value) == 'object'){
                    $j.each(value, function (i,e) {
                        var input = document.createElement("input");
                        input.setAttribute('type',"text");
                        input.setAttribute("name",key+'[]');
                        input.setAttribute("value",e);
                        form.appendChild(input);
                    });
                }
            });

            document.body.appendChild(form);
            form.submit();
        },

        submitBatchOperationsExport: function() {
            var allBatchOperationsUserIds = '';

            jQuery('.export-email-data').each(function(){
                value = jQuery(this).val();
                if (value && value != -1) {
                    allBatchOperationsUserIds = allBatchOperationsUserIds != ''
                        ? allBatchOperationsUserIds + ',' + value
                        : value;
                }
            });

            jQuery('#batchOperations_user_ids').val(allBatchOperationsUserIds);
            jQuery('#batchOperations_export_form').submit();
        },
    }

}
